import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

// Styles

const StyledMap = styled.div`
  ${() => css`
    position: relative;
    padding-bottom: 56.25%;
    width: 100%;
    display: block;
  `};
`;

const StyledIFrame = styled.iframe`
  ${() => css`
    margin: auto;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `};
`;

// JSX

export const Map: FC = () => (
  <StyledMap>
    <StyledIFrame
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2500.8287941323906!2d-0.6219280229249075!3d51.18537837174201!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4875d1d92d2a0a19%3A0xc3ea501f029a474c!2sTrade%20Direct%20Insurance%20Services%20Ltd!5e0!3m2!1sen!2suk!4v1690380648381!5m2!1sen!2suk "
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="map"
    />
  </StyledMap>
);

export default Map;
